import { createSelector } from "@reduxjs/toolkit";
import { selectedRoomNr, selectHttpGetRoomsCurrentFloorResult } from "./httpRoomSelectors";
import { IRoomSummary } from "@multiconsult-group/multiplacer-core";

export const selectActiveSingleRoomSummary = createSelector(
  [selectedRoomNr, selectHttpGetRoomsCurrentFloorResult],
  (roomNr, rooms): IRoomSummary | null => {
    if (roomNr == null || rooms == null) {
      return null;
    }
    return rooms[roomNr] ?? null;
  }
);
